import api from "./apiClient";

const BASE = process.env.VUE_APP_API_BASE_URL + "/api/v2/";

export default {
  async listar(filtros) {
    const { data } = await api.post(BASE + "meta/insights", filtros);
    return data;
  },
  async sincronizar(days = 7) {
    const { data } = await api.post(BASE + "meta/sincronizar", { days });
    return data;
  },
  async filtros(conEliminadas = false) {
    const { data } = await api.post(BASE + "meta/filtros", { con_eliminadas: conEliminadas });
    return data;
  },
  async vincular(vinculos) {
    const { data } = await api.post(BASE + "meta/vincular", { vinculos });
    return data;
  },
  async campanas() {
    const { data } = await api.post(BASE + "meta/campanas");
    return data;
  },
  async informe(params) {
    const { data } = await api.post(BASE + "meta/informe", params);
    return data;
  },
  async exportarJson(desde, hasta, { fx = null, tipster_id = null, canal_id = null, ruta = 'meta/export-json' } = {}) {
    const params = { desde, hasta };
    if (fx)         params.fx         = fx;
    if (tipster_id) params.tipster_id = tipster_id;
    if (canal_id)   params.canal_id   = canal_id;
    const { data } = await api.get(BASE + ruta, { params });
    return data;
  },
};
